$(document).ready(function() {
  
  //hero slier 
  $('.slick-slider-hero').slick({
      dots: true,
      infinite: true,
      speed: 200,
      fade: false,
      cssEase: 'linear',
      arrows: false
  });
  
   //hero slier 
  $('.can-slider').slick({
      dots: false,
      infinite: true,
      speed: 900,
      fade: false,
      arrows: true,
      slidesToShow: 5
  });

  $('#product-arrow-left').click(function(){
     $('.featured-product-gallery-navigation__previous').first().click();   
  });

  $('#product-arrow-right').click(function(){
     $('.featured-product-gallery-navigation__next').first().click();   
  });


  if($('#color-swatch-container-hook').length > 0){
    //color swatch size variant
    window.setTimeout(function(){
      let cVariant = '' 
        
        $('.product-block--variant_picker .input-radio__input').each(function(){
          if($(this).attr('checked')){
            cVariant = ($(this).val());

            $('#color-swatch-container-hook a').each(function(){
              let cURL = '';
              cURL = $(this).attr('href');
              cURL += '?size=' +  cVariant;
              $(this).attr('href', cURL);
            });
          }
        })
  
    },2000)
  }

  $('.product-block--variant_picker .input-radio__input').click(function(){
      let cVariant = '' 
       cVariant = ($(this).val());
       $('#color-swatch-container-hook a').each(function(){
         let cURL = '';
         cURL = $(this).attr('href');
         if (cURL.indexOf('?') > -1) {
              cURL = $(this).attr('href').split('?');
              cURL = cURL[0] + '?size=' +  cVariant;
              $(this).attr('href', cURL);
          } else {
             cURL += '?size=' +  cVariant;
             $(this).attr('href', cURL);
          }
        });
  })

  window.setTimeout(function(){
    let cURL = window.location.href;
  
    if(cURL.includes('?size')) {
     
      cURL = cURL.split('=');
      $('.product-block--variant_picker .input-radio__input').each(function(){
          console.log(cURL[1]);
          if($(this).attr('value') == cURL[1]){
           $(this).click();
          }
        })
    }
  
  }, 500)
  
  
  
  //collection slick slider 
  $('.slick-slider-collections').slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: true,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }     
    ]  
  });
  
  //delegated slider clicks
  $('#product-slider-button-prev').click(function(){
  	$('#collection-prev-button').click();
  });
  
  $('#product-slider-button-next').click(function(){
  	$('#collection-next-button').click();
  });

  $('.single-faq').click(function(){
    $(this).toggleClass('active');
  })  


});